module.exports = __webpack_public_path__ + "static/media/nature_1.c7d6e606.jpg";